/* eslint-disable prettier/prettier */

import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Divider } from '@mui/material';
import InformacionGeneral from './forms/informacionGeneral';
import InformacionGeneralMenor from './forms/informacionMenor';
import AntecedentesHeredoFamiliares from './forms/antecedentesHeredoFamiliares';
import AntecedentesPrenatales from './forms/antecedentesPrenatales';
const steps = [
  {
    label: 'Informacion general',
    component: <InformacionGeneral />
  },
  {
    label: 'INFORMACIÓN GENERAL DEL MENOR',
     component: <InformacionGeneralMenor />
  },
  {
    label: 'ANTECEDENTES HEREDOFAMILIARES',
     component: <AntecedentesHeredoFamiliares />
  },
  {
    label: 'ANTECEDENTES PRENATALES',
    component: <AntecedentesPrenatales />
  },
  {
    label: 'ANTECEDENTES PERINATALES',
     component: <Box>hola mundo</Box>
  },
  {
    label: 'ANTECEDENTES PERSONALES NO PATOLÓGICOS DEL MENOR',
     component: <Box>hola mundo</Box>
  },
  {
    label: 'EVALUACIÓN AUDITIVA Y LINGÜÍSTICA',
     component: <Box>hola mundo</Box>
  },
   {
    label: 'DESARROLLO MOTOR',
     component: <Box>hola mundo</Box>
  },
   {
    label: 'INFORMACIÓN ADICIONAL',
     component: <Box>hola mundo</Box>
  },
   {
    label: 'DOCUMENTACIÓN ADMINISTRATIVA',
     component: <Box>hola mundo</Box>
  },
   {
    label: 'DOCUMENTACIÓN CLÍNICA',
     component: <Box>hola mundo</Box>
  },
   {
    label: 'EINFORMACIÓN ADICIONAL',
     component: <Box>hola mundo</Box>
  },
];



export default function VerticalLinearStepper() {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <Box >
      <Stepper activeStep={activeStep} orientation="vertical" sx={{background:"#1a2035 !important"}}  >
        {steps.map((step, index) => (
          <Step key={step.label} >
            <StepLabel >
              {step.label}
            </StepLabel>
            <StepContent sx={{marginLeft:"6px", borderLeft:"0.125rem solid rgba(159, 201, 255,0.5)"}}>
                {step.component}
              <MDBox textAlign="right">
                 <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 1, mr: 1 }}
                    size='small'
                    color='primary'
                  >
                    {index === steps.length - 1 ? 'Crear solicitud' : 'Continuar'}
                  </Button>
                  <Button
                    variant="contained"
                    disabled={index === 0}
                    onClick={handleBack}
                    sx={{ mt: 1, mr: 1 }}
                    color='secondary'
                     size='small'
                  >
                    Volver
                  </Button> 
              </MDBox>
              <Divider />
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}